import { ValidateCouponDto } from "types/dto/ValidateCouponDto";
import { ApiService } from "./apiService";



export const validateCoupon = async (dto: ValidateCouponDto) => {
    return await ApiService.get(`coupons/validate?code=${dto.code}&price=${dto.price}`);
}